import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '@app/services/loader/loader.service';
import { finalize } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {

    /** Requests still in flight. The bar stays up until the last one settles. */
    private pending = 0;

    constructor(
        private loaderService: LoaderService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Background refreshes the person did not ask for should not flash the bar.
        if (req.headers.has('skipLoader')) {
            return next.handle(req.clone({ headers: req.headers.delete('skipLoader') }));
        }

        this.pending++;
        this.showLoader();

        // finalize rather than waiting for a response or an error: a request cancelled by
        // navigating away mid-flight produces neither, and used to leave the bar running for
        // good. Counting also keeps the first request to finish from hiding it while others
        // are still loading.
        return next.handle(req).pipe(finalize(() => this.onEnd()));
    }

    private onEnd(): void {
        this.pending = Math.max(0, this.pending - 1);
        if (this.pending === 0) this.hideLoader();
    }

    private showLoader(): void {
        this.loaderService.show();
    }

    private hideLoader(): void {
        this.loaderService.hide();
    }
}